import { AgeButton } from "./AgeButton";

interface Props {
  onSelectAge: (data: number[]) => void;
  selectedAges: any[];
  available?: number[];
}

export default function AgeSelector(props: Props) {
  function onSelectAge(e, i) {
    e.preventDefault();

    if (props.onSelectAge) {
      props.onSelectAge(i);
    }
  }

  function renderAges() {
    const content = [];

    content.push(
      <AgeButton
        age={0}
        key="0"
        onClick={(e) => onSelectAge(e, 0)}
        isSelected={
          props.selectedAges.includes(0) || props.selectedAges.includes("0")
        }
        disabled={props.available && !props.available.includes(0)}
      >
        &lt; 1
      </AgeButton>
    );

    for (let i = 1; i <= 19; i++) {
      content.push(
        <AgeButton
          isSelected={
            props.selectedAges.includes(i) ||
            props.selectedAges.includes(i.toString())
          }
          age={i}
          key={i}
          onClick={(e) => onSelectAge(e, i)}
          disabled={props.available && !props.available.includes(i)}
        >
          {i}
        </AgeButton>
      );
    }

    content.push(
      <AgeButton
        age={99}
        key="21+"
        onClick={(e) => onSelectAge(e, 99)}
        isSelected={
          props.selectedAges.includes(99) || props.selectedAges.includes("99")
        }
        disabled={props.available && !props.available.includes(99)}
      >
        &gt; 20
      </AgeButton>
    );

    return content;
  }

  return (
    <div className="grid grid-cols-7 overflow-hidden rounded border border-borderGray">
      {renderAges()}
    </div>
  );
}
